import { render, staticRenderFns } from "./MbgTextInput.vue?vue&type=template&id=4a300ab7&"
import script from "./MbgTextInput.vue?vue&type=script&lang=js&"
export * from "./MbgTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports